import React, {useEffect, useState, useContext, useRef} from "react";
import {useParams} from "react-router-dom";
import FormSectionPreview from "../../../components/form-section-preview/FormSectionPreview";
import FormFieldPreview from "../../../components/form-field-preview/FormFieldPreview";
import {StoreContext} from "../../../store/StoreContext";
import {handleCleanTitle} from "../../../helpers";
import _ from "lodash";
import useMain from "../../../hooks/useMain";
import useFormParams from "../../../hooks/useFormParams";
import FormSubSectionPreview from "../../../components/form-sub-section-preview/FormSubSectionPreview";
import FormLabelFieldPreview from "../../../components/form-label-field-preview/FormLabelFieldPreview";
import FormValueFieldPreview from "../../../components/form-value-field-preview/FormValueFieldPreview";
import ReactToPrint from "react-to-print";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faPrint} from "@fortawesome/free-solid-svg-icons";
import FindingGridPreview from "../../../components/finding-grid-preview/FindingGridPreview";
import CommitmentsGridPreview from "../../../components/commitments-grid-preview/CommitmentsGridPreview";
import {getUsers} from "../../../mongo-db/users";
import {getLocal, putLocal} from "../../../helpers/local-storage";

const Preview = () => {
  const {templateId, formId, rol} = useParams();

  const {
    setAppTitle,
    formsAD,
    formsAM,
    formsP,
    setLoading,
    platform,
  } = useContext(StoreContext);
  const {fetchSavedForm, fetchImagesByForm} = useMain();
  const componentRef = useRef();

  const [form, setForm] = useState({});
  const [findings, setFindings] = useState([]);
  const [commitments, setCommitments] = useState([]);
  const [collaborators, setCollaborators] = useState([]);
  const [sections, setSections] = useState([]);
  const [machines, setMachines] = useState({});
  const [elements, setElements] = useState([]);
  const [questionsMachine, setQuestionsMachine] = useState([]);
  const [fields, setFields] = useState({});

  const [areas, setAreas] = useState([]);
  const [centers, setCenters] = useState([]);
  const [categories, setCategories] = useState([]);
  const [findingCategories, setFindingCategories] = useState([]);
  const [questions, setQuestions] = useState([]);
  const [machineTypes, setMachineTypes] = useState([]);
  const [itemsMachine, setItemsMachine] = useState([]);
  const [machinesSso, setMachinesSso] = useState([]);
  const [findingCriticality, setFindingCriticality] = useState([]);
  const [responsible, setResponsible] = useState([]);
  const [results, setResults] = useState([]);

  const [itemMachine, setItemMachine] = useState(null);
  const [actions, setActions] = useState([]);

  // Datos de nuevas colecciones (Centers, FormParams)
  const formParamsData = useFormParams(templateId);

  const fetchDataByForm = _formId => {
    setLoading(true);

    Promise.all([fetchSavedForm(_formId), fetchImagesByForm(_formId)])
      .then(result => {
        const _form = result[0];
        const _images = result[1];

        const _findings = _.map(_form.hallazgos, finding => {
          const images = _.get(_images, `images.${finding.HallazgoId}`, []);
          return {...finding, images};
        });

        setFindings(_findings);
        setCommitments(_form.compromisos);
        setCollaborators(_form?.collaborators || []);
        setElements(_form?.elements || []);
        setSections(_form?.sections || []);
        setMachines(_form?.machines || {});
        setFields(_form?.Preguntas || {});
      })
      .finally(() => setLoading(false));
  };

  const getQuestionBySection = yn => {
    const _question = questions.find(q => String(q.id) === String(yn));
    return _question?.title || "";
  };

  const getResult = resultId => {
    const _result = results.find(r => String(r.id) === String(resultId));
    return _result?.title || "";
  };

  const getMachineSso = machineId => {
    const _machineSso = machinesSso.find(
      m => String(m.id) === String(machineId)
    );
    return _machineSso?.title || "";
  };

  const getMachineType = machineId => {
    const _machineType = machineTypes.find(
      m => String(m.id) === String(machineId)
    );
    return _machineType?.title || "";
  };

  const getScope = scopeId => {
    const _scope = categories.find(c => String(c.id) === String(scopeId));
    return _scope?.title || "";
  };

  const getArea = areaId => {
    const _area = areas.find(a => String(a.id) === String(areaId));
    return _area?.title || "";
  };

  const getCenter = centerId => {
    const _center = centers.find(a => String(a.id) === String(centerId));
    return _center?.title || "";
  };

  const getYesOrNo = value => {
    return value === "1" ? "Si" : value === "2" ? "No" : "";
  };

  useEffect(() => {
    const _itemMachine = itemsMachine.find(i => {
      return String(i.id) === String(fields["p-2_6"]);
    });
    setItemMachine(_itemMachine);
  }, [fields, itemsMachine]);

  useEffect(() => {
    if (!fields["p-2_5"]) return;

    const _questions = formParamsData.ssoQuestions.filter(q =>
      String(q.machineId) === String(fields["p-2_5"])
    );
    setQuestionsMachine(_questions);
  }, [formParamsData.ssoQuestions, fields["p-2_5"]]);

  useEffect(() => {
    if (!form?.TemplateId) return;

    const applyUsers = (usersData) => {
      const mapped = usersData
        .filter(user => user.profile !== 1)
        .map(user => ({
          value: user.email,
          label: user.name + (user.position ? ` - ${user.position}` : ""),
        }));
      setResponsible(mapped);
    };

    const cached = getLocal("sso_users_cache", null);
    if (cached) applyUsers(cached);

    if (navigator.onLine) {
      getUsers().then(usersData => {
        if (usersData?.length) {
          putLocal("sso_users_cache", usersData);
          applyUsers(usersData);
        }
      });
    }
  }, [form]);

  // Datos de nuevas colecciones (Centers, FormParams)
  useEffect(() => {
    setAreas(formParamsData.areas);
    setCenters(formParamsData.flatCenters);
    setCategories(formParamsData.categories);
    setQuestions(formParamsData.yesOrNo);
    setFindingCategories(formParamsData.findingCategories);
    setFindingCriticality(formParamsData.findingCriticality);
    setResults(formParamsData.results);
    setMachineTypes(formParamsData.machineTypes);
    setItemsMachine(formParamsData.itemsMachine);
    setMachinesSso(formParamsData.ssoMachines);
  }, [formParamsData.ready, formParamsData.areas, formParamsData.categories, formParamsData.machineTypes]);

  const isIncidentReport = form?.Titulo?.includes("Reporte de Incidentes");

  useEffect(() => {
    if (!templateId) return;

    const forms = [...formsAD, ...formsAM, ...formsP];
    const _form = forms.find(f => f.TemplateId.toString() === templateId);
    const _title = handleCleanTitle(_form?.Titulo, rol);
    setForm(_form);
    setAppTitle(_title);
  }, [formsAD, formsAM, formsP, templateId]);

  useEffect(() => {
    if (!formId) return;
    fetchDataByForm(formId);
  }, []);

  useEffect(() => {
    let _actions = _.cloneDeep(form?.Acciones || []);
    if (formId) {
      _actions = _.cloneDeep(_actions).map(a => {
        a.Preguntas = a.Preguntas.filter(q => {
          const yn = !!fields[`psn-${a.Id}-${q.Id}`];
          const ob = !!fields[`po-${a.Id}-${q.Id}`];
          return !q.deleted || yn || ob;
        });
        return a;
      });
      _actions = _.cloneDeep(_actions).filter(a => {
        return (
          !a.deleted ||
          a.Preguntas.some(q => {
            const yn = !!fields[`psn-${a.Id}-${q.Id}`];
            const ob = !!fields[`po-${a.Id}-${q.Id}`];
            return yn || ob;
          })
        );
      });
    } else {
      _actions = _actions.filter(a => !a.deleted);
      _actions = _actions.map(a => {
        a.Preguntas = a.Preguntas.filter(q => !q.deleted);
        return a;
      });
    }
    setActions(_actions);
  }, [form?.Acciones, fields, formId]);

  return (
    <>
      <style type="text/css" media="print">
        {`@page { 
            margin: 30px 50px !important; 
          }; 
          @media print { 
            .page-break { 
              display: none
            }
          }`}
      </style>
      <div ref={componentRef}>
        <div className="row">
          <div className="col-12">
            <h4 className="h4 text-primary-cermaq text-center mt-3 mb-4">
              {form?.Titulo}
            </h4>
          </div>
        </div>

        <FormSectionPreview title="I IDENTIFICACIÓN GENERAL" show={true}>
          <div className="row">
            <div className="col-12 col-md-3">
              <FormFieldPreview
                number={1}
                label="Área"
                value={getArea(fields["p-1_1"])}
              />
            </div>
            <div className="col-12 col-md-3">
              <FormFieldPreview
                number={2}
                label="Instalación"
                value={getCenter(fields["p-1_2"])}
              />
            </div>
            <div className="col-12 col-md-3">
              <FormFieldPreview
                number={3}
                label="Responsable"
                value={fields["p-1_3"]}
              />
            </div>
            <div className="col-12 col-md-3">
              <FormFieldPreview
                number={4}
                label="Fecha registro"
                value={fields["p-1_4"]}
              />
            </div>
            {isIncidentReport && (
              <>
                <div className="col-12 col-md-3">
                  <FormFieldPreview
                    number={5}
                    label="Categoría"
                    value={getScope(fields["p-2_1"])}
                  />
                </div>
                <div className="col-12 col-md-3">
                  <FormFieldPreview
                    number={6}
                    label="Descripción"
                    value={fields["p-2_2"]}
                  />
                </div>
                <div className="col-6 col-md-2">
                  <FormFieldPreview
                    number={7}
                    label="Horario Inicio"
                    value={fields["p-2_3"]}
                  />
                </div>
                <div className="col-6 col-md-2">
                  <FormFieldPreview
                    number={8}
                    label="Horario Término"
                    value={fields["p-2_4"]}
                  />
                </div>
              </>
            )}
          </div>
        </FormSectionPreview>

        <FormSectionPreview title="II IDENTIFICACIÓN ESPECIFICA" show={!isIncidentReport && form?.FormType !== 12}>
          <div className="row">
            {form?.FormType !== 11 && rol !== "Jefatura" && (
              <div className="col-12 col-md-3">
                <FormFieldPreview
                  number={1}
                  label="Alcance"
                  value={getScope(fields["p-2_1"])}
                />
              </div>
            )}
            {form?.FormType !== 11 && (
              <div className="col-12 col-md-3">
                <FormFieldPreview
                  number={2}
                  label="Descripción de la actividad observada"
                  value={fields["p-2_2"]}
                />
              </div>
            )}
            <div className="col-12 col-md-3">
              <FormFieldPreview
                number={3}
                label="Horario Inicio"
                value={fields["p-2_3"]}
              />
            </div>
            <div className="col-12 col-md-3">
              <FormFieldPreview
                number={4}
                label="Horario Término"
                value={fields["p-2_4"]}
              />
            </div>
            {form?.FormType === 5 && (
              <div className="col-12 col-md-3">
                <FormFieldPreview
                  number={5}
                  label="Habitable"
                  value={fields["p-2_5"]}
                />
              </div>
            )}
          </div>

          <FormSubSectionPreview
            title="Identificación maquinaria o instrumento"
            show={form?.FormType === 2 || form?.FormType === 4}
          >
            <div className="row">
              <div className="col-12 col-md-3">
                <FormFieldPreview
                  number={5}
                  label="Tipo Maq"
                  value={getMachineType(fields["p-2_5"])}
                />
              </div>
              <div className="col-12 col-md-3">
                <FormFieldPreview
                  number={6}
                  label="Item"
                  value={itemMachine?.title}
                />
              </div>
              <div className="col-12 col-md-3">
                <FormFieldPreview
                  number={7}
                  label="Matrícula"
                  value={fields["p-2_7"]}
                />
              </div>
              <div className="col-12 col-md-3">
                <FormFieldPreview
                  number={8}
                  label="Marca"
                  value={fields["p-2_8"]}
                />
              </div>
              <div className="col-12 col-md-3">
                <FormFieldPreview
                  number={9}
                  label="Modelo"
                  value={fields["p-2_9"]}
                />
              </div>
              <div className="col-12 col-md-3">
                <FormFieldPreview
                  number={10}
                  label="Capacidad"
                  value={fields["p-2_10"]}
                />
              </div>
            </div>
          </FormSubSectionPreview>

          <FormSubSectionPreview
            title="Información colaboradores"
            show={form?.FormType === 7 || form?.FormType === 8}
          >
            <div className="table-responsive-sm">
              <table className="table">
                <thead>
                  <tr>
                    <th scope="col">
                      <FormLabelFieldPreview label="Id" />
                    </th>
                    <th>
                      <FormLabelFieldPreview label="Rut" />
                    </th>
                    <th>
                      <FormLabelFieldPreview label="Nombre" />
                    </th>
                    <th>
                      <FormLabelFieldPreview label="Puesto del trabajador observado" />
                    </th>
                    <th>
                      <FormLabelFieldPreview label="Comentarios" />
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {collaborators.map((collaborator, index) => (
                    <tr key={collaborator.id}>
                      <th scope="row">
                        <FormValueFieldPreview value={index + 1} />
                      </th>
                      <td>
                        <FormValueFieldPreview
                          value={collaborators[index]?.rut}
                          className="text-nowrap"
                        />
                      </td>
                      <td>
                        <FormValueFieldPreview
                          value={collaborators[index]?.name}
                          className="text-nowrap"
                        />
                      </td>
                      <td>
                        <FormValueFieldPreview
                          value={collaborators[index]?.position}
                        />
                      </td>
                      <td style={{minWidth: 300}}>
                        <FormValueFieldPreview
                          value={collaborators[index]?.comments}
                        />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </FormSubSectionPreview>

          <FormSubSectionPreview
            title="Asistencia"
            show={form?.FormType === 11}
          >
            <div className="table-responsive-sm">
              <table className="table">
                <thead>
                  <tr>
                    <th scope="col">
                      <FormLabelFieldPreview label="Id" />
                    </th>
                    <th>
                      <FormLabelFieldPreview label="Rut" />
                    </th>
                    <th>
                      <FormLabelFieldPreview label="Nombre" />
                    </th>
                    <th>
                      <FormLabelFieldPreview label="Puesto del trabajador" />
                    </th>
                    <th>
                      <FormLabelFieldPreview label="CI" />
                    </th>
                    <th>
                      <FormLabelFieldPreview label="Firma" />
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {collaborators.map((collaborator, index) => (
                    <tr key={collaborator.id}>
                      <th scope="row">
                        <FormValueFieldPreview value={index + 1} />
                      </th>
                      <td>
                        <FormValueFieldPreview
                          value={collaborators[index]?.rut}
                          className="text-nowrap"
                        />
                      </td>
                      <td>
                        <FormValueFieldPreview
                          value={collaborators[index]?.name}
                          className="text-nowrap"
                        />
                      </td>
                      <td>
                        <FormValueFieldPreview
                          value={collaborators[index]?.position}
                        />
                      </td>
                      <td style={{minWidth: 100}}>
                        <div className="d-flex flex-column align-items-start">
                          {collaborators[index]?.CI && (
                            <img
                              height={70}
                              src={collaborators[index]?.CI}
                              alt={collaborators[index]?.rut}
                            />
                          )}
                          <small
                            className="mt-1 text-muted"
                            style={{fontSize: "0.75rem"}}
                          >
                            {collaborators[index]?.dateTimeCI}
                          </small>
                        </div>
                      </td>
                      <td style={{minWidth: 100}}>
                        <div className="d-flex flex-column align-items-start">
                          {collaborators[index]?.signature && (
                            <img
                              height={70}
                              src={collaborators[index]?.signature}
                              alt={collaborators[index]?.rut}
                            />
                          )}
                          <small
                            className="mt-1 text-muted"
                            style={{fontSize: "0.75rem"}}
                          >
                            {collaborators[index]?.dateTimeSignature}
                          </small>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </FormSubSectionPreview>

          <FormSubSectionPreview
            title="Identificación maquinaria o instrumento"
            show={form?.FormType === 9}
          >
            <div className="row">
              <div className="col-12 col-md-4">
                <FormFieldPreview
                  number={5}
                  label="Tipo Maq"
                  value={getMachineSso(fields["p-2_5"])}
                />
              </div>
            </div>
          </FormSubSectionPreview>

          <FormSubSectionPreview title="Conductor" show={form?.FormType === 10}>
            <div className="row">
              <div className="col-12 col-md-3">
                <FormFieldPreview
                  number={5}
                  label="Nombre conductor"
                  value={fields["p-2_5"]}
                />
              </div>
              <div className="col-12 col-md-3">
                <FormFieldPreview
                  number={6}
                  label="Rut"
                  value={fields["p-2_6"]}
                />
              </div>
              <div className="col-12 col-md-3">
                <FormFieldPreview
                  number={7}
                  label="Licencia al día"
                  value={getYesOrNo(fields["p-2_7"])}
                />
              </div>
              <div className="col-12 col-md-3">
                <FormFieldPreview
                  number={8}
                  label="Permiso de circulación"
                  value={getYesOrNo(fields["p-2_8"])}
                />
              </div>
              <div className="col-12 col-md-3">
                <FormFieldPreview
                  number={9}
                  label="Seguro obligatorio"
                  value={getYesOrNo(fields["p-2_9"])}
                />
              </div>
              <div className="col-12 col-md-3">
                <FormFieldPreview
                  number={10}
                  label="Padrón"
                  value={getYesOrNo(fields["p-2_10"])}
                />
              </div>
              <div className="col-12 col-md-3">
                <FormFieldPreview
                  number={11}
                  label="Permiso del Min"
                  value={getYesOrNo(fields["p-2_11"])}
                />
              </div>
            </div>
          </FormSubSectionPreview>
        </FormSectionPreview>

        <FormSectionPreview title="III DETALLE" show={form?.FormType === 11}>
          <div className="row d-none d-md-flex">
            <div className="col-4">
              <FormLabelFieldPreview label={"Tareas y Trabajos a ejecutar"} />
            </div>
            <div className="col-4">
              <FormLabelFieldPreview label="Identificación de Peligros" />
            </div>
            <div className="col-4">
              <FormLabelFieldPreview label="Medidas Preventivas" />
            </div>
          </div>

          {_.map(actions, (action, indexA) => (
            <div key={action.Id + indexA} className="row mt-4">
              {_.map(action.Preguntas, (question, indexQ) => (
                <div
                  key={question.Id + indexQ}
                  className="border-bottom col-12 mb-4"
                >
                  <div className="row">
                    <div className="col-12 col-md-4">
                      <FormLabelFieldPreview
                        label={"Tareas y Trabajos a ejecutar"}
                        className="d-block d-md-none"
                      />
                      <p className="m-0">{question?.Tareas?.Titulo}</p>
                      <ul className="fs-6">
                        {_.map(question?.Tareas?.Items, (item, i) => (
                          <li key={i}>{item}</li>
                        ))}
                      </ul>
                    </div>
                    <div className="col-12 col-md-4">
                      <FormLabelFieldPreview
                        label="Identificación de Peligros"
                        className="d-block d-md-none"
                      />
                      <ul className="fs-6">
                        {_.map(question?.Peligros, (danger, i) => (
                          <li key={i}>{danger}</li>
                        ))}
                      </ul>
                    </div>
                    <div className="col-12 col-md-4">
                      <FormLabelFieldPreview
                        label="Medidas Preventivas"
                        className="d-block d-md-none"
                      />
                      <ul className="fs-6">
                        {_.map(question?.Medidas, (preventiveMeasure, i) => (
                          <li key={i}>{preventiveMeasure}</li>
                        ))}
                      </ul>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          ))}

          <div className="border-bottom row mb-4">
            <h6 className="text-blue-cermaq mb-3">Otros</h6>
          </div>

          {sections.map((sec, index) => (
            <div
              key={sec.id}
              className={`row mb-4 ${
                index < sections.length - 1 ? "border-bottom" : ""
              }`}
            >
              <div className="col-12 col-md-4">
                <FormLabelFieldPreview
                  label="Tareas y Trabajos a ejecutar"
                  className="d-blok d-md-none"
                />
                <p className="m-0">{sections[index]?.tasksTitle || ""}</p>
                <ul className="fs-6">
                  {_.map(sections[index]?.tasksItems, (item, i) => (
                    <li key={i}>{item}</li>
                  ))}
                </ul>
              </div>
              <div className="col-12 col-md-4">
                <FormLabelFieldPreview
                  label="Identificación de Peligros"
                  className="d-blok d-md-none"
                />
                <ul className="fs-6">
                  {_.map(sections[index]?.dangers, (item, i) => (
                    <li key={i}>{item}</li>
                  ))}
                </ul>
              </div>
              <div className="col-12 col-md-4">
                <FormLabelFieldPreview
                  label="Medidas Preventivas"
                  className="d-blok d-md-none"
                />
                <ul className="fs-6">
                  {_.map(sections[index]?.precautionaryMeasures, (item, i) => (
                    <li key={i}>{item}</li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </FormSectionPreview>

        <FormSectionPreview
          title="II DETALLE INSPECCIÓN"
          show={isIncidentReport}
        >
          <div className="row d-none d-md-flex">
            <div className="col-5">
              <FormLabelFieldPreview label="Conceptos" />
            </div>
            <div className="col-2">
              <FormLabelFieldPreview label="Evaluación" className="text-center" />
            </div>
            <div className="col-5">
              <FormLabelFieldPreview label="Hallazgos" />
            </div>
          </div>
          {_.map(actions, (action, indexA) => {
            const lesionQuestion = action.Preguntas?.find(q =>
              q.Titulo?.toLowerCase().includes("lesión") || q.Titulo?.toLowerCase().includes("lesion")
            );
            const otherQuestions = action.Preguntas?.filter(q =>
              !(q.Titulo?.toLowerCase().includes("lesión") || q.Titulo?.toLowerCase().includes("lesion"))
            ) || [];

            return (
              <div key={action.Id + indexA} className="row">
                <div className="col-12">
                  <div className="border-top mt-2 mb-3">
                    <h6 className="text-blue-cermaq mt-3">{action.Titulo}</h6>
                  </div>
                </div>

                {lesionQuestion && (
                  <div className="col-12 mb-4">
                    <div className="row">
                      <div className="col-12 col-md-5">
                        <FormLabelFieldPreview
                          label="Concepto"
                          className="d-block d-md-none"
                        />
                        <FormLabelFieldPreview
                          number={`${indexA + 1}.1`}
                          label={lesionQuestion.Titulo}
                          className="mb-3"
                        />
                      </div>
                      <div className="col-12 col-md-2">
                        <FormLabelFieldPreview
                          label="Evaluación"
                          className="d-block d-md-none"
                        />
                        <FormValueFieldPreview
                          className="text-md-center mb-3"
                          value={getQuestionBySection(
                            fields[`psn-${action.Id}-${lesionQuestion.Id}`]
                          )}
                        />
                      </div>
                      <div className="col-12 col-md-5">
                        <FormLabelFieldPreview
                          label="Hallazgos"
                          className="d-block d-md-none"
                        />
                        <FormValueFieldPreview
                          value={fields[`po-${action.Id}-${lesionQuestion.Id}`]}
                        />
                      </div>
                    </div>
                  </div>
                )}

                {_.map(otherQuestions, (question, indexQ) => (
                  <div key={question.Id + indexQ} className="col-12 mb-4">
                    <div className="row">
                      <div className="col-12 col-md-5">
                        <FormLabelFieldPreview
                          label="Concepto"
                          className="d-block d-md-none"
                        />
                        <FormLabelFieldPreview
                          number={`${indexA + 1}.${lesionQuestion ? indexQ + 2 : indexQ + 1}`}
                          label={question.Titulo}
                          className="mb-3"
                        />
                      </div>
                      <div className="col-12 col-md-2">
                        <FormLabelFieldPreview
                          label="Evaluación"
                          className="d-block d-md-none"
                        />
                        <FormValueFieldPreview
                          className="text-md-center mb-3"
                          value={getQuestionBySection(
                            fields[`psn-${action.Id}-${question.Id}`]
                          )}
                        />
                      </div>
                      <div className="col-12 col-md-5">
                        <FormLabelFieldPreview
                          label="Hallazgos"
                          className="d-block d-md-none"
                        />
                        <FormValueFieldPreview
                          value={fields[`po-${action.Id}-${question.Id}`]}
                        />
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            );
          })}
        </FormSectionPreview>

        <FormSectionPreview
          title="III DETALLE INSPECCIÓN"
          show={
            (form?.FormType === 1 ||
            form?.FormType === 2 ||
            form?.FormType === 7 ||
            form?.FormType === 10) && !isIncidentReport
          }
        >
          <div className="row d-none d-md-flex">
            <div className="col-5">
              <FormLabelFieldPreview
                label={form?.FormType === 7 ? "Preguntas" : "Conceptos"}
              />
            </div>
            <div className="col-2">
              <FormLabelFieldPreview
                label="Evaluación"
                className="text-center"
              />
            </div>
            <div className="col-5">
              <FormLabelFieldPreview label="Hallazgos" />
            </div>
          </div>
          {_.map(actions.filter(a => !a.Preguntas?.some(q => q.Tareas)), (action, indexA) => (
            <div key={action.Id + indexA} className="row">
              <div className="col-12">
                <div className="border-top mt-2 mb-3">
                  <h6 className="text-blue-cermaq mt-3">{action.Titulo}</h6>
                </div>
              </div>
              {_.map(action.Preguntas, (question, indexQ) => (
                <div key={question.Id + indexQ} className="col-12 mb-4">
                  <div className="row">
                    <div className="col-12 col-md-5">
                      <FormLabelFieldPreview
                        label={form?.FormType === 7 ? "Pregunta" : "Concepto"}
                        className="d-block d-md-none"
                      />
                      <FormLabelFieldPreview
                        number={`${indexA + 1}.${indexQ + 1}`}
                        label={question.Titulo}
                        className="mb-3"
                      />
                    </div>
                    <div className="col-12 col-md-2">
                      <FormLabelFieldPreview
                        label="Evaluación"
                        className="d-block d-md-none"
                      />
                      <FormValueFieldPreview
                        className="text-md-center mb-3"
                        value={getQuestionBySection(
                          fields[`psn-${action.Id}-${question.Id}`]
                        )}
                      />
                    </div>
                    <div className="col-12 col-md-5">
                      <FormLabelFieldPreview
                        label="Hallazgos"
                        className="d-block d-md-none"
                      />
                      <FormValueFieldPreview
                        value={fields[`po-${action.Id}-${question.Id}`]}
                      />
                    </div>
                  </div>
                </div>
              ))}
            </div>
          ))}
        </FormSectionPreview>

        <FormSectionPreview
          title="III DETALLE INSPECCIÓN"
          show={form?.FormType === 3 || form?.FormType === 4}
        >
          <div className="row d-none d-md-flex">
            <div className="col-6">
              <FormLabelFieldPreview label="Conceptos" />
            </div>
            <div className="col-2">
              <FormLabelFieldPreview
                label="Evaluación"
                className="text-center"
              />
            </div>
            <div className="col-4">
              <FormLabelFieldPreview label="Hallazgos" />
            </div>
          </div>

          {sections.map((sec, index) => (
            <div key={sec.id} className="row">
              <div className="col-12">
                <FormLabelFieldPreview
                  label={`Nombre sección ${index + 1}`}
                  className="border-top text-blue-cermaq pt-3 mt-3 mb-2"
                />
              </div>
              <div className="col-12 col-md-5 mb-2">
                <FormLabelFieldPreview
                  label="Concepto"
                  className="d-blok d-md-none"
                />
                <FormValueFieldPreview value={sec?.sectionName} />
              </div>
              <div className="col-12 col-md-2 mb-2">
                <FormLabelFieldPreview
                  label="Evaluación"
                  className="d-blok d-md-none"
                />
                <FormValueFieldPreview
                  value={getQuestionBySection(sec?.evaluation)}
                  className="text-md-center"
                />
              </div>
              <div className="col-12 col-md-5 mb-2">
                <FormLabelFieldPreview
                  label="Hallazgos"
                  className="d-blok d-md-none"
                />
                <FormValueFieldPreview value={sec?.observations} />
              </div>
            </div>
          ))}
        </FormSectionPreview>

        <FormSectionPreview
          title="III DETALLE INSPECCIÓN"
          show={form?.FormType === 5}
        >
          <div className="row d-none d-md-flex">
            <div className="col-1">
              <FormLabelFieldPreview label="Cantidad" />
            </div>
            <div className="col-3">
              <FormLabelFieldPreview label="Descripción" />
            </div>
            <div className="col-3">
              <FormLabelFieldPreview label="Ubicación" />
            </div>
            <div className="col-2">
              <FormLabelFieldPreview
                label="Evaluación"
                className="text-center"
              />
            </div>
            <div className="col-3">
              <FormLabelFieldPreview label="Hallazgos" />
            </div>
          </div>

          {_.map(actions, (action, indexA) => (
            <div key={action.Id + indexA} className="row">
              <div className="col-12">
                <div className="border-top mt-2 mb-3">
                  <h6 className="text-blue-cermaq mt-3">{action.Titulo}</h6>
                </div>
              </div>

              {_.map(action.Preguntas, (question, indexQ) => (
                <div key={question.Id + indexQ} className="col-12 mb-4">
                  <div className="row">
                    <div className="col-12 col-md-1 mb-2">
                      <FormLabelFieldPreview
                        label="Cantidad"
                        className="d-blok d-md-none"
                      />
                      <FormLabelFieldPreview
                        number={`${indexA + 1}.${indexQ + 1}`}
                        className="mb-3"
                      />
                    </div>
                    <div className="col-12 col-md-3 mb-2">
                      <FormLabelFieldPreview
                        label="Descripción"
                        className="d-blok d-md-none"
                      />
                      <FormLabelFieldPreview
                        number={`${indexA + 1}.${indexQ + 1}.1`}
                        label={question.Titulo}
                        className="mb-3"
                      />
                    </div>
                    <div className="col-12 col-md-3 mb-2">
                      <FormLabelFieldPreview
                        label="Ubicación"
                        className="d-blok d-md-none"
                      />
                      <FormLabelFieldPreview
                        number={`${indexA + 1}.${indexQ + 1}.2`}
                        label={question.Titulo2}
                        className="mb-3"
                      />
                    </div>
                    <div className="col-12 col-md-2 mb-2">
                      <FormLabelFieldPreview
                        label="Evaluación"
                        className="d-blok d-md-none"
                      />
                      <FormValueFieldPreview
                        value={getQuestionBySection(
                          fields[`psn-${action.Id}-${question.Id}`]
                        )}
                        className="text-md-center mb-3"
                      />
                    </div>
                    <div className="col-12 col-md-3 mb-2">
                      <FormLabelFieldPreview
                        label="Hallazgos"
                        className="d-blok d-md-none"
                      />
                      <FormValueFieldPreview
                        value={fields[`po-${action.Id}-${question.Id}`]}
                        className="mb-3"
                      />
                    </div>
                  </div>
                </div>
              ))}
            </div>
          ))}
        </FormSectionPreview>

        <FormSectionPreview
          title="III DETALLE INSPECCIÓN"
          show={form?.FormType === 6}
        >
          <FormSubSectionPreview
            title="Listado de elementos evaluados"
            show={true}
          >
            <div className="table-responsive-sm">
              <table className="table">
                <thead>
                  <tr>
                    <th scope="col">
                      <FormLabelFieldPreview label="Id" />
                    </th>
                    <th>
                      <FormLabelFieldPreview
                        label="Nombre elemento"
                        className="text-nowrap"
                      />
                    </th>
                    <th style={{minWidth: 300}}>
                      <FormLabelFieldPreview label="Descripción" />
                    </th>
                    <th>
                      <FormLabelFieldPreview label="Estado" />
                    </th>
                    <th>
                      <FormLabelFieldPreview label="Comentarios" />
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {elements.map((element, index) => (
                    <tr key={element.id}>
                      <th scope="row">
                        <FormValueFieldPreview value={index + 1} />
                      </th>
                      <td>
                        <FormValueFieldPreview value={element.name} />
                      </td>
                      <td>
                        <FormValueFieldPreview value={element.description} />
                      </td>
                      <td>
                        <FormValueFieldPreview value={elements[index]?.state} />
                      </td>
                      <td>
                        <FormValueFieldPreview value={element.comments} />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </FormSubSectionPreview>
        </FormSectionPreview>

        <FormSectionPreview
          title="III DETALLE INSPECCIÓN"
          show={form?.FormType === 8}
        >
          <div className="row d-none d-md-flex">
            <div className="col-5">
              <FormLabelFieldPreview label="Conceptos" />
            </div>
            <div className="col-2">
              <FormLabelFieldPreview
                label="Evaluación"
                className="text-center"
              />
            </div>
            <div className="col-5">
              <FormLabelFieldPreview label="Hallazgos" />
            </div>
          </div>
          {_.map(collaborators, (collaborator, index) => (
            <div key={index} className="row">
              <div className="col-12">
                <div className="border-top mt-3 mb-3">
                  <h6 className="text-blue-cermaq text-uppercase mt-3 mb-0">
                    {collaborator.name} | {collaborator.rut}
                  </h6>
                </div>
              </div>

              {_.map(collaborator?.sections, (sec, secIndex) => (
                <div key={secIndex} className="row mb-3">
                  <div className="col-12">
                    <FormLabelFieldPreview
                      label={`Nombre sección ${secIndex + 1}`}
                      className="mb-2"
                    />
                  </div>
                  <div className="col-12 col-md-5">
                    <FormLabelFieldPreview
                      label="Concepto"
                      className="d-blok d-md-none"
                    />
                    <FormValueFieldPreview
                      value={sec.section}
                      className="mb-3"
                    />
                  </div>
                  <div className="col-12 col-md-2">
                    <FormLabelFieldPreview
                      label="Evaluación"
                      className="d-blok d-md-none"
                    />
                    <FormValueFieldPreview
                      value={getQuestionBySection(sec.yn)}
                      className="text-md-center mb-3"
                    />
                  </div>
                  <div className="col-12 col-md-5">
                    <FormLabelFieldPreview
                      label="Hallazgos"
                      className="d-blok d-md-none"
                    />
                    <FormValueFieldPreview
                      value={sec.observation}
                      className="mb-3"
                    />
                  </div>
                </div>
              ))}
            </div>
          ))}
        </FormSectionPreview>

        <FormSectionPreview
          title="III DETALLE INSPECCIÓN"
          show={form?.FormType === 9}
        >
          <div className="row d-none d-md-flex">
            <div className="col-5">
              <FormLabelFieldPreview label="Preguntas" />
            </div>
            <div className="col-2">
              <FormLabelFieldPreview
                label="Evaluación"
                className="text-center"
              />
            </div>
            <div className="col-5">
              <FormLabelFieldPreview label="Hallazgos" />
            </div>
          </div>

          {_.map(actions, (action, indexA) => (
            <div key={action.Id + indexA} className="row">
              <div className="col-12">
                <div className="border-top mt-2 mb-3">
                  <h6 className="text-blue-cermaq mt-3">{action.Titulo}</h6>
                </div>
              </div>
              {_.map(action.Preguntas, (question, indexQ) => (
                <div key={question.Id + indexQ} className="col-12 mb-4">
                  <div className="row">
                    <div className="col-12 col-md-5">
                      <FormLabelFieldPreview
                        label="Pregunta"
                        className="d-block d-md-none"
                      />
                      <FormFieldPreview
                        number={`${indexA + 1}.${indexQ + 1}`}
                        label={question.Titulo}
                      />
                    </div>
                    <div className="col-12 col-md-2">
                      <FormLabelFieldPreview
                        label="Evaluación"
                        className="d-block d-md-none"
                      />
                      <FormValueFieldPreview
                        value={getQuestionBySection(
                          fields[`psn-${action.Id}-${question.Id}`]
                        )}
                        className="text-md-center mb-3"
                      />
                    </div>
                    <div className="col-12 col-md-5">
                      <FormLabelFieldPreview
                        label="Hallazgos"
                        className="d-block d-md-none"
                      />
                      <FormValueFieldPreview
                        value={fields[`po-${action.Id}-${question.Id}`]}
                        className="mb-3"
                      />
                    </div>
                  </div>
                </div>
              ))}
            </div>
          ))}

          <div className="row">
            <div className="col-12">
              <div className="border-top mt-2 mb-3">
                <h6 className="text-blue-cermaq mt-3">
                  INSPECCIÓN ESPECÍFICA DE LA MAQUINARIA
                </h6>
              </div>
            </div>

            {_.map(questionsMachine, (question, index) => (
              <div key={question.id} className="col-12 mb-4">
                <div className="row">
                  <div className="col-12 col-md-5">
                    <FormLabelFieldPreview
                      label="Pregunta"
                      className="d-block d-md-none"
                    />
                    <FormLabelFieldPreview
                      number={`${form.Acciones.length + 1}.${index + 1}`}
                      label={question.title}
                      className="mb-3"
                    />
                  </div>
                  <div className="col-12 col-md-2">
                    <FormLabelFieldPreview
                      label="Evaluación"
                      className="d-block d-md-none"
                    />
                    <FormValueFieldPreview
                      value={getQuestionBySection(machines[index]?.yesOrNo)}
                      className="text-md-center mb-3"
                    />
                  </div>
                  <div className="col-12 col-md-5">
                    <FormLabelFieldPreview
                      label="Hallazgos"
                      className="d-block d-md-none"
                    />
                    <FormValueFieldPreview
                      value={machines[index]?.comments}
                      className="mb-3"
                    />
                  </div>
                </div>
              </div>
            ))}
          </div>
        </FormSectionPreview>

        {/* ============ BUCEO PREVIEW - FormType 12 ============ */}
        <FormSectionPreview title="II DATOS DE LA FAENA" show={form?.FormType === 12}>
          <div className="row">
            <div className="col-12 col-md-4">
              <FormFieldPreview number={1} label="Localización exacta" value={fields["buceo-localizacion"]} />
            </div>
            <div className="col-12 col-md-4">
              <FormFieldPreview number={2} label="Ejecución del trabajo" value={fields["buceo-ejecucion"]} />
            </div>
            <div className="col-12 col-md-4">
              <FormFieldPreview number={3} label="Tipo de trabajo" value={fields["buceo-tipoTrabajo"]} />
            </div>
          </div>
          <div className="row mt-3">
            <div className="col-12 col-md-4">
              <FormFieldPreview number={4} label="Supervisor de Buceo" value={`${fields["buceo-supNombre"] || ""} ${fields["buceo-supFono"] ? `- Fono: ${fields["buceo-supFono"]}` : ""}`} />
            </div>
            <div className="col-12 col-md-4">
              <FormFieldPreview number={5} label="Jefe de Centro" value={`${fields["buceo-jefeNombre"] || ""} ${fields["buceo-jefeFono"] ? `- Fono: ${fields["buceo-jefeFono"]}` : ""}`} />
            </div>
            <div className="col-12 col-md-4">
              <FormFieldPreview number={6} label="Capitán o Patrón embarcación" value={`${fields["buceo-capitanNombre"] || ""} ${fields["buceo-capitanFono"] ? `- Fono: ${fields["buceo-capitanFono"]}` : ""}`} />
            </div>
          </div>
          <div className="row mt-3">
            <div className="col-12">
              <FormFieldPreview number={7} label="Descripción de los trabajos" value={fields["buceo-descripcion"]} />
            </div>
          </div>
          <div className="border-top mt-3 pt-3">
            <FormLabelFieldPreview label="Trabajadores involucrados en la Faena" className="mb-2" />
            <div className="table-responsive">
              <table className="table table-sm">
                <thead><tr><th>N°</th><th>Nombre</th><th>RUN</th><th>Firma</th></tr></thead>
                <tbody>
                  {collaborators.map((coll, i) => (
                    <tr key={i}>
                      <td>{i + 1}</td>
                      <td>{coll.name}</td>
                      <td>{coll.rut}</td>
                      <td>{coll.signature ? <img src={coll.signature} alt="Firma" style={{maxHeight: 40}} /> : "—"}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </FormSectionPreview>
        <FormSectionPreview title="III ETAPAS DEL TRABAJO, PELIGROS Y CONTROLES" show={form?.FormType === 12}>
          <div className="row d-none d-md-flex">
            <div className="col-4">
              <FormLabelFieldPreview label="Etapa del Trabajo" />
            </div>
            <div className="col-4">
              <FormLabelFieldPreview label="Peligros Presentes" />
            </div>
            <div className="col-4">
              <FormLabelFieldPreview label="Controles Operacionales" />
            </div>
          </div>

          {/* Etapas fijas del template (Accion Id "1") */}
          {actions.filter(a => a.Id === "1").map((action, indexA) => (
            <div key={action.Id + indexA} className="row mt-4">
              {_.map(action.Preguntas, (question, indexQ) => (
                <div key={question.Id + indexQ} className="border-bottom col-12 mb-4">
                  <div className="row">
                    <div className="col-12 col-md-4">
                      <FormLabelFieldPreview label="Etapa del Trabajo" className="d-block d-md-none" />
                      <p className="m-0">{question?.Tareas?.Titulo}</p>
                      <ul className="fs-6">
                        {_.map(question?.Tareas?.Items, (item, i) => (
                          <li key={i}>{item}</li>
                        ))}
                      </ul>
                    </div>
                    <div className="col-12 col-md-4">
                      <FormLabelFieldPreview label="Peligros Presentes" className="d-block d-md-none" />
                      <ul className="fs-6">
                        {_.map(question?.Peligros, (danger, i) => (
                          <li key={i}>{danger}</li>
                        ))}
                      </ul>
                    </div>
                    <div className="col-12 col-md-4">
                      <FormLabelFieldPreview label="Controles Operacionales" className="d-block d-md-none" />
                      <ul className="fs-6">
                        {_.map(question?.Medidas, (medida, i) => (
                          <li key={i}>{medida}</li>
                        ))}
                      </ul>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          ))}

          {/* Etapas adicionales (Otros) */}
          <div className="border-bottom row mb-4">
            <h6 className="text-blue-cermaq mb-3">Otros</h6>
          </div>

          {sections.map((sec, index) => (
            <div key={sec.id} className={`row mb-4 ${index < sections.length - 1 ? "border-bottom" : ""}`}>
              <div className="col-12 col-md-4">
                <FormLabelFieldPreview label="Etapa del Trabajo" className="d-block d-md-none" />
                <ul className="fs-6">
                  {_.map(sections[index]?.tasksItems, (item, i) => (
                    <li key={i}>{item}</li>
                  ))}
                </ul>
              </div>
              <div className="col-12 col-md-4">
                <FormLabelFieldPreview label="Peligros Presentes" className="d-block d-md-none" />
                <ul className="fs-6">
                  {_.map(sections[index]?.dangers, (item, i) => (
                    <li key={i}>{item}</li>
                  ))}
                </ul>
              </div>
              <div className="col-12 col-md-4">
                <FormLabelFieldPreview label="Controles Operacionales" className="d-block d-md-none" />
                <ul className="fs-6">
                  {_.map(sections[index]?.precautionaryMeasures, (item, i) => (
                    <li key={i}>{item}</li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </FormSectionPreview>

        <FormSectionPreview title="IV DETALLE INSPECCIÓN" show={form?.FormType === 12}>
          <div className="row d-none d-md-flex">
            <div className="col-8">
              <FormLabelFieldPreview label="Conceptos" />
            </div>
            <div className="col-4">
              <FormLabelFieldPreview label="Evaluación" className="text-center" />
            </div>
          </div>
          {_.map(actions.filter(a => !a.Preguntas?.some(q => q.Tareas)), (action, indexA) => (
            <div key={action.Id + indexA} className="row">
              <div className="col-12">
                <div className="border-top mt-2 mb-3">
                  <h6 className="text-blue-cermaq mt-3">{action.Titulo}</h6>
                </div>
              </div>
              {_.map(action.Preguntas, (question, indexQ) => (
                <div key={question.Id + indexQ} className="col-12 mb-4">
                  <div className="row">
                    <div className="col-12 col-md-8">
                      <FormLabelFieldPreview label="Concepto" className="d-block d-md-none" />
                      <FormLabelFieldPreview number={`${indexA + 1}.${indexQ + 1}`} label={question.Titulo} className="mb-3" />
                    </div>
                    <div className="col-12 col-md-4">
                      <FormLabelFieldPreview label="Evaluación" className="d-block d-md-none" />
                      <FormValueFieldPreview className="text-md-center mb-3" value={getQuestionBySection(fields[`psn-${action.Id}-${question.Id}`])} />
                    </div>
                  </div>
                </div>
              ))}
            </div>
          ))}
        </FormSectionPreview>

        {/* ============ FIN BUCEO PREVIEW ============ */}

        <FormSectionPreview
          title={isIncidentReport ? "III DETALLE HALLAZGOS ENCONTRADOS" : "IV DETALLE HALLAZGOS ENCONTRADOS"}
          show={form?.FormType !== 11 && form?.FormType !== 12}
        >
          <div className="row">
            <div className="col-12">
              <FindingGridPreview
                findings={findings}
                categories={findingCategories}
              />
            </div>
          </div>
        </FormSectionPreview>

        <FormSectionPreview
          title="V COMPROMISOS ADQUIRIDOS"
          show={form?.FormType !== 11 && form?.FormType !== 12 && !isIncidentReport}
        >
          <div className="row">
            <div className="col-12">
              <CommitmentsGridPreview
                commitments={commitments}
                findings={findings}
                responsible={responsible}
              />
            </div>
          </div>
        </FormSectionPreview>

        {form?.FormType === 12 && (form?.Declaracion || []).length > 0 && (
          <FormSectionPreview title="DECLARACIÓN" show={true}>
            <div className="mb-3 p-3 bg-light border rounded">
              <ul className="mb-2">
                {(form?.Declaracion || []).map((item, i) => (
                  <li key={i}>{item}</li>
                ))}
              </ul>
              <p className="mb-0 fw-bold">
                Declaración leída y comprendida:{" "}
                <span className={fields["buceo-declaracionLeida"] ? "text-success" : "text-danger"}>
                  {fields["buceo-declaracionLeida"] ? "Sí" : "No"}
                </span>
              </p>
            </div>
          </FormSectionPreview>
        )}

        <FormSectionPreview
          title={form?.FormType === 12 ? "V RESULTADO INSPECCIÓN" : "VI RESULTADO INSPECCIÓN"}
          show={form?.FormType !== 11 && !isIncidentReport}
        >
          <div className="row">
            <div className="col-12 col-md-4">
              <FormFieldPreview
                label="Resultado"
                number={1}
                value={getResult(fields["p-5"])}
              />
            </div>
          </div>
          {form?.FormType === 12 && fields["buceo-observacionesRechazo"] && (
            <div className="row mt-3">
              <div className="col-12">
                <FormFieldPreview
                  label="Observaciones a subsanar"
                  number={2}
                  value={fields["buceo-observacionesRechazo"]}
                />
              </div>
            </div>
          )}
        </FormSectionPreview>
      </div>

      <div className="row pt-3 pb-5">
        <div className="col-12">
          <div className="d-flex justify-content-center w-100">
            {platform === "web" && (
              <ReactToPrint
                trigger={() => {
                  return (
                    <button
                      type="button"
                      className="btn btn-secondary fs-6 mr-auto"
                    >
                      <FontAwesomeIcon icon={faPrint} />
                      <span className="ms-3">Imprimir</span>
                    </button>
                  );
                }}
                content={() => componentRef.current}
              />
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default Preview;
